module.exports = __webpack_public_path__ + "02_hair_gold.7d97d5e9.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/female/layer5/02_hair_gold.png
// module id = Joas
// module chunks = 0